import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { NavLink, Container, Wrapper, Title, Text, Mark } from './styles';

const VideoItem = ({ id, videoId, urlParam, title, thumbnail, price }) => {
  const { t } = useTranslation('app');

  return (
    <Container key={id}>
      <NavLink to={`/videos/${id}/${urlParam}`} $url={thumbnail}>
        {price === 0 && <Mark>{t('Free')}</Mark>}
      </NavLink>
      <Wrapper>
        {videoId && <Text>{t('Video ID', { id: videoId })}</Text>}
        <Title>{title}</Title>
      </Wrapper>
    </Container>
  );
};

VideoItem.propTypes = {
  id: PropTypes.string.isRequired,
  videoId: PropTypes.string,
  urlParam: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  price: PropTypes.number,
};

VideoItem.defaultProps = {
  videoId: null,
  price: 0,
};

export default VideoItem;
